'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputNumber = require('./InputNumber');

var _InputNumber2 = _interopRequireDefault(_InputNumber);

var _InputNumberGroup = require('./InputNumberGroup');

var _InputNumberGroup2 = _interopRequireDefault(_InputNumberGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_InputNumber2["default"].InputNumberGroup = _InputNumberGroup2["default"];

exports["default"] = _InputNumber2["default"];
module.exports = exports['default'];